import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from './constants';

export interface IConfig {
    production: boolean;
    apiUrl: string;
    apiKey: string;
    env: string;
    launchdarklyApiKey: string;
    appSyncRegion: string;
    onlineStoreService: string;
    onlineStoreServiceApiKey: string;
    clientAuthUrl: string;
    reCaptchaSiteKey: string;
    stripeApiKey: string;
}

@Injectable()
export class ConfigService {
    private cachedConfig!: IConfig;

    public get config(): IConfig {
        return this.cachedConfig;
    }

    constructor(@Inject(APP_CONFIG) config: IConfig) {
        this.cachedConfig = config;
    }
}
